import { Fragment, h } from 'preact';
import style from "./accountActions.module.css";
import {iconUser} from "../../../../assets/";
import {Link} from "preact-router/match";
import {useAppContext, useUserContext} from "../../../../contexts";

const AccountActions = () => {
    // Destructures the need data from the user context
    const [data, {signOut}] = useUserContext();
    
    const {accessibilityFont, highContrast} = useAppContext();

    // Dropdown content variable already checking whether user is logged in or not
    const dropdownContent = !data.isSignedIn ? (
        <ul 
            className={` divide divide-y ${highContrast ? "grayBackground highLabelFourth" : ""}`} 
            data-testid="account-actions-ul-not-logged"
        >
            <li className={style.dropdownItem}>
                <Link 
                    href={"/entre"} 
                    className={`
                        w-full h-full flex flex-row items-center justify-center text-[#666] 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                    data-testid={`login-link`}
                >
                    Entre / Cadastre-se
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link 
                    href={"/entre"} 
                    className={`
                        w-full h-full flex flex-row items-center justify-center text-[#666] 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Meus pedidos
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link 
                    href={"/entre"} 
                    className={`w-full h-full flex flex-row items-center justify-center text-[#666] 
                    ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}`}
                >
                    Meus dados
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link 
                    href={"/entre"} 
                    className={`
                        w-full h-full flex flex-row items-center justify-center text-[#666] 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Endereços
                </Link>
            </li>
        </ul>
    ) : (
        <ul className={`divide divide-y ${highContrast ? "grayBackground hover:highLabelFourth" : ""}`} data-testid="account-actions-ul-logged">
            <li className={style.dropdownItem}>
                <Link 
                    href={"/meus-pedidos"} 
                    className={`
                        w-full h-full flex flex-row items-center justify-center 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Meus pedidos
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link 
                    href={"/editar-conta"} 
                    className={`
                        w-full h-full flex flex-row items-center justify-center 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Meus dados
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <Link 
                    href={"/enderecos"} 
                    className={`
                        w-full h-full flex flex-row items-center justify-center 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Endereços
                </Link>
            </li>
            <li className={style.dropdownItem}>
                <button
                    type={"button"}
                    onClick={() => signOut().then(() => {})}
                    className={`
                        w-full h-full flex flex-row items-center justify-center uppercase 
                        ${highContrast ? "highLabelFirst" : "hover:text-sabin-red-default"}
                    `}
                >
                    Sair
                </button>
            </li>
        </ul>
    );

    return (
        <Fragment>
            <div className={style.accountActions} data-testid={"account-actions-container"}>
                <div className={"flex flex-col items-end py-3"}>
                    <p 
                        className={`hidden md:block uppercase leading-none text-black ${highContrast ? "text-white" : ""}`} 
                        style={{fontSize: `${14+accessibilityFont}px`}}
                        data-testid="account-actions-username"
                    >
                        {!data.isSignedIn ? "Entre / Cadastre-se" : data.firstName}
                    </p>
                    <p 
                        className={`
                            block md:hidden uppercase leading-none text-black 
                            ${highContrast ? "text-white" : ""}
                        `}
                        style={{fontSize: `${12+accessibilityFont}px`}}
                        data-testid={`header-mobile-account-label`}
                    >
                        {!data.isSignedIn ? (
                            "Entre"
                        ) : (
                            data.firstName
                        )}
                    </p>
                    <p 
                        className={`uppercase leading-none text-sabin-red-default md:text-sabin-text-2 ${style.accountText} ${highContrast ? "highTitleThird" : ""}`}
                        style={{fontSize: window.innerWidth >= 768 ? `${12+accessibilityFont}px` : `${10+accessibilityFont}px`}}
                    >
                        Minha conta
                    </p>
                </div>
                <img
                    src={iconUser}
                    alt={"User icon"}
                    className={`${style.userIcon}  ${highContrast ? style.accountYellowFilter : ""}`}
                    data-testid="account-actions-img"
                />
                <div 
                    className={`absolute select-none uppercase w-full top-[48px] text-center right-0 shadow rounded px-4 bg-white border border-gray-200 ${highContrast ? "grayBackground" : ""} ${style.dropdownContainer}`}
                    style={{fontSize: `${12+accessibilityFont}px`}}
                >
                    {dropdownContent}
                </div>
            </div>
        </Fragment>
    )
}

export default AccountActions;
